<template>
  <a-card class="mb50">
    <table-wrapper
      v-if="showTable"
      :row-key="'uuid'"
      ref="tableWrappers"
      :dataSource="value"
      :showCheckbox="true"
      :columns="detailColumns"
    >
      <template #buttons>
        <a-space> </a-space>
      </template>

      <template #isPhotograph="{ record }">
        <img
          class="tb-img"
          v-if="record.isPhotograph == 1"
          :src="isZHXH ? checkRightGreen : checkRight"
          alt=""
        />
        <span v-else>-</span>
      </template>
      <template #isExplain="{ record }">
        <img
          class="tb-img"
          v-if="record.isExplain == 1"
          :src="isZHXH ? checkRightGreen : checkRight"
          alt=""
        />
        <span v-else>-</span>
      </template>
    </table-wrapper>

    <div class="service-list" v-if="value && !showTable">
      <div class="service-item" v-for="(item, index) in value">
        <div class="round" :class="{ grey: !item?.finishedFlag }" v-if="index == 0">
          <b :class="{ grey: !item?.finishedFlag }"></b>
        </div>
        <div class="round" :class="{ grey: !item?.finishedFlag }" v-else>
          <img v-if="!!item?.finishedFlag" :src="isZHXH ? IconCheckedGreen : IconChecked" />
          <img v-else :src="IconCheckedGrey" />
        </div>
        <h5 class="item-title">
          <span class="h-t">{{ item?.workPackagesName }}</span
          ><span class="h-time" v-if="item?.workDetails">{{
            item?.workDetails?.lastModifiedTime
          }}</span>
        </h5>
        <a-row class="item-imgs" :gutter="[16, 10]" v-if="item?.workDetails">
          <template v-for="imgs in item?.workDetails?.imageUrlList">
            <a-col :span="8" class="item-img" v-if="imgs">
              <div>
                <img :src="imgs" alt="" />
              </div>
            </a-col>
          </template>
        </a-row>
        <div class="item-des" v-if="item?.workDetails">
          <div class="item-des-d" v-if="item?.workDetails.remark">
            {{ item?.workDetails.remark }}
          </div>
        </div>
        <!-- 客户验收节点满意度 -->
        <div class="callback-info" v-if="item?.workPackagesName == '客户验收' && item?.ticketSatisfaction">
          <span class="callback-item">满意度：{{ item.ticketSatisfactionDesc }}</span>
        </div>
        <!-- 回访节点详情 -->
        <div class="callback-info" v-if="item?.ticketCallBackInfoResp">
          <span class="callback-item">回访人：{{ item.ticketCallBackInfoResp.callBackUserName }}</span>
          <span class="callback-item">回访方式：{{ item.ticketCallBackInfoResp.callBackTypeDesc }}</span>
          <span class="callback-item">问题解决情况：{{ item.ticketCallBackInfoResp.problemResolutionStatusDesc }}</span>
          <span class="callback-item">发生费用：{{ item.ticketCallBackInfoResp.repairCosts != null ? item.ticketCallBackInfoResp.repairCosts + ' 元' : '-' }}</span>
          <span class="callback-item" style="word-break: break-all;">备注：{{ item.ticketCallBackInfoResp.remark || '-' }}</span>
        </div>
        <div
          class="line"
          :class="{ grey: !item?.workDetails }"
          v-if="index != value.length - 1"
        ></div>
      </div>
    </div>
  </a-card>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  Ref,
  onMounted,
  ref,
  PropType,
  watch,
  nextTick,
} from "vue";
import { WorkPackageTableRecord } from "./work-package-table.interface";
import { detailColumns } from "./work-package-table.constant";
import checkRight from "@/assets/images/check-right.png";
import checkRightGreen from "@/assets/images/check-right-green.png";
import { IsZhiHuiXingHe } from "@/core/hooks/SetTheme";
import IconChecked from "@/assets/images/icon-checked.png";
import IconCheckedGrey from "@/assets/images/icon-checked-grey.png";
import IconCheckedGreen from "@/assets/images/icon-checked-green.png";
export default defineComponent({
  name: "WorkPackageTableDetail",
  components: {},
  props: {
    value: { type: Array as PropType<WorkPackageTableRecord[]>, default: [] },
    showTable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const state = reactive<any>({
      records: [new WorkPackageTableRecord()],
      selectedUuids: [],
    });
    return {
      ...toRefs(state),
      detailColumns,
      checkRight,
      checkRightGreen,
      isZHXH: IsZhiHuiXingHe(),
      IconCheckedGreen,
      IconChecked,
      IconCheckedGrey,
    };
  },
});
</script>
<style scoped lang="less">
.tb-img {
  width: 16px;
}

.h-t {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-style: normal;
}
.h-time {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  text-align: right;
  font-style: normal;
}
.item-title {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.service-item {
  display: flex;
  flex-flow: column;
  padding-left: 30px;
  position: relative;
}
.service-list {
  overflow: hidden;
  width: 100%;
}

.item-des {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.84);
  text-align: left;
  font-style: normal;
}
.line {
  position: absolute;
  width: 1px;
  background: #2f7bff;
  top: 15px;
  bottom: -12px;
  left: 6px;
}
.round {
  position: absolute;
  top: 10px;
  width: 12px;
  height: 12px;

  left: 0;
  border-radius: 50%;
  border: 1px solid #2f7bff;
  overflow: hidden;
  line-height: 0px;
  b {
    display: block;
    background: #2f7bff;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    border-radius: 50%;
    margin: 2px;
  }
  img {
    width: 120%;
    height: 120%;
    border-radius: 50%;
    vertical-align: bottom;
    margin-top: -1px;
    margin-left: -1px;
  }
}
.grey {
  background-color: #cacaca !important;
  border-color: #cacaca !important;
}
.item-img {
  text-align: center;
  div {
    background: #f4f6f9;
  }
  img {
    width: 40px;
  }
}
.callback-info {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
  padding: 4px 0;
  margin-bottom: 12px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
}
.callback-item {
  white-space: nowrap;
}
</style>
